import { Injectable } from '@angular/core';

export enum Level {
  FATAL = 0,
  WARNING,
  NORMAL,
  VERBOSE,
  FINE,
}

interface Message {
  level: Level;
  text: string;
};

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  reportingLevel = Level.VERBOSE;
  private msgs: Message[] = [];

  constructor() { }

  public logFatal(message: string) {
    this.log(Level.FATAL, message);
  }

  public logWarning(message: string) {
    this.log(Level.WARNING, message);
  }

  public logNormal(message: string) {
    this.log(Level.NORMAL, message);
  }

  public logVerbose(message: string) {
    this.log(Level.VERBOSE, message);
  }

  public logFine(message: string) {
    this.log(Level.FINE, message);
  }

  public log(level: Level, text: string) {
    this.msgs.push({
      level,
      text
    })
    if (level <= this.reportingLevel) {
      console.log(text);
    }
  }

  public clear() {
    this.msgs = [];
  }

  get messages() {
    return this.msgs;
  }
}
